import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLazyQuery } from '@apollo/client';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import Wrapper from '../Wrapper';
import MiniGertieGhostie from '../../../assets/miniGertieGhostie.svg';
import { categoriesQuery } from '../../../gql/cms';

const StyledEmpty = styled(Container)`
  display: flex;
  align-items: center;
  min-height: 50px;
  padding-top: 10px;
  padding-bottom: 10px;

  img {
    margin-right: 5px;
  }
`;

const ArticleCategorySuggest = ({
  children,
  className,
  onClickSuggest,
  icon,
  type,
  onFetchData,
  hideList,
  params,
  ...props
}) => {
  const [fetch, { data }] = useLazyQuery(categoriesQuery);

  const { localsearchCMSCategories } = data || {};
  const { categories } = localsearchCMSCategories || {};

  useEffect(() => {
    if (onFetchData && categories) onFetchData(categories);
  }, [categories, onFetchData]);

  const suggestFormatted = ({ name }) => ({
    value: name,
    formatted: name,
  });

  const fetchData = async value => {
    if (value) {
      await fetch({
        variables: {
          categoryName: value.trim(),
          size: 4,
        },
      });
    }
  };

  return (
    <Wrapper
      list={!hideList && categories && !!categories.length ? categories : []}
      fetchData={fetchData}
      onClickSuggest={onClickSuggest}
      suggestFormatted={suggestFormatted}
      className={className}
      icon={icon}
      emptyText={
        <StyledEmpty className="ArticleCategorySuggest__empty">
          <img src={MiniGertieGhostie} alt="" />
          Drat, looks like we have no articles on this topic. Please try
          another.
        </StyledEmpty>
      }
      {...props}
    >
      {children}
    </Wrapper>
  );
};

ArticleCategorySuggest.propTypes = {
  children: PropTypes.node,
  onClickSuggest: PropTypes.func,
  onFetchData: PropTypes.func,
  className: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.string,
  params: PropTypes.shape({}),
};

ArticleCategorySuggest.defaultProps = {
  children: undefined,
  className: undefined,
  icon: undefined,
  onClickSuggest: () => {},
  onFetchData: undefined,
  type: '',
  params: {},
};
export default ArticleCategorySuggest;
